import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
  PLATFORM_ID,
  ViewChild, AfterViewInit, OnDestroy
} from "@angular/core";

import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Router, ActivatedRoute } from "@angular/router";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";
import { Observable, Observer } from "rxjs";
import { FileService } from "src/app/services/file.service";
import { DataService } from "src/app/services/data.service";
import { makeStateKey, Meta, TransferState } from "@angular/platform-browser";
var FileSaver = require("file-saver");
import { Title } from "@angular/platform-browser";
import { MetaService } from "src/app/services/meta.service";
import { isPlatformServer } from "@angular/common";
// import { SocialService } from "ngx-social-button";
import { REQUEST } from "@nguniversal/express-engine/tokens";
import { Request } from "express";
import { MatSnackBar } from "@angular/material/snack-bar";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-ai-image",
  templateUrl: "./ai-image.component.html",
  styleUrls: ["./ai-image.component.scss"],
})
export class AIIllustrationComponent implements OnInit {
  @ViewChild("closebutton") closebutton: ElementRef;
  @ViewChild("licenseModalModal") licenseModalModal: ElementRef;

  @ViewChild('masonryContainer') masonryContainer!: ElementRef;
  @ViewChild('contentColumn') contentColumn!: ElementRef;
  gap = 24;
  resizeObserver!: ResizeObserver;
  resizeTimer: any;

  minItemWidth = 264; // controls how many columns per device
  imageLoadCount = 0;
  illusImageLoaded = false;
illusWidth = 1;
illusHeight = 1;
  id: any = "";
  illusData: any = [{}];
  imgUrl = "";
  base64Image: any;
  getRequests = [];
  isFetchingLimit = true;
  relatedIllus = [];
  relatedData: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  visibleRelatedData: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];   // rendered data
  pageSize = 20;
  currentPage = 1;
  isLoadingMore = false;

  user: any;
  wishList: any = [];
  wishListAdded: boolean = false;
  tDate: any;
  limit: any = 0;
  downloadData: any = [];
  isShow = false;
  limitExceeds = false;
  currentUrl: string = "";
  titleStr: string = "";
  loader = true;
  imageLoad = true;

  encodedWhatsAppUrl: string = "";
  encodedFacebookUrl: string = "";
  shareObj = {
    href: encodeURIComponent(
      `https://illusbook.com/ai-image/${this.id}/${this.titleStr}`
    ),
    hashtag: "#FACEBOOK-SHARE-HASGTAG",
  };
  share = encodeURIComponent(
    `https://illusbook.com/ai-image/${this.id}/${this.titleStr}`
  );
  appId = "219273858882440";

  ILLUS_KEY = makeStateKey<any>("illusData");

  constructor(
    private afs: AngularFirestore,
    public router: Router,
    private route: ActivatedRoute,
    private fileService: FileService,
    private dataService: DataService,
    private meta: Meta, // private socialService: SocialService,
    private title: Title,
    public metaService: MetaService,
    private _snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  copyAttribution(event: Event): void {
    event.preventDefault();

    const attribution = `<a href="https://illusbook.com/" target="_blank" rel="noopener noreferrer">Designed by Illusbook</a>`;

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(attribution)
        .then(() => {
          this._snackBar.open("Attribution copied!", "Okay", {
            duration: 1000,
            panelClass: ["custom-snackbar"],
          });
        })
        .catch((err) => {
          console.error("Failed to copy!", err);
        });
    } else {
      console.warn("Clipboard API not supported");
    }
  }

   getSEOImage(url: string): string {
      return buildSEOImageUrl(url);
    }

  getRelatedIllustration() {
    //console.log("this.id", this.id);
    this.relatedData = [];
    this.loader = false;
    this.imageLoad = false;
    this.relatedIllus.map(async (data) => {
      const get = await this.afs.collection(`filesMaster/`, (res) => {
        return res
          .where("isAIIllustration", "==", true)
          .where("id", "!=", this.id)
          .where("relatedZ", "array-contains", data)
          .where("status", "==", "Published");
      });

      const getdata = await get.valueChanges();
      getdata.subscribe((data) => {
        const result = data.map((item) => {
          const result = this.relatedData.filter((itemD) => {
            return itemD.id === item["id"];
          });
          if (result.length === 0) {
            this.relatedData.push(item);
          }
          return item;
        });
        // this.relatedData = [...this.relatedData, ...data];
        // //console.log(this.relatedData);
        // //console.log(result);
         this.initIllusLoad();   // ✅ after data assignment
      });
      return getdata;
    });
    // //console.log(this.relatedData);
    this.relatedData.filter(this.onlyUnique);
  }

onIllusImageLoad(event: Event) {
  const img = event.target as HTMLImageElement;

  this.illusWidth = img.naturalWidth;
  this.illusHeight = img.naturalHeight;

  this.illusImageLoaded = true;
}

  onImageLoad(index: number, event: Event) {
    const img = event.target as HTMLImageElement;
    this.relatedData[index].imageLoad = true;

    // store real image ratio
    this.relatedData[index].ratio =
      img.naturalHeight / img.naturalWidth;

    img.classList.add('loaded');

    this.scheduleMasonry();
  }

  // ngAfterViewInit() {
  //   this.scheduleMasonry();

  //   this.resizeObserver = new ResizeObserver(() => {
  //     this.scheduleMasonry();
  //   });

  //   this.resizeObserver.observe(this.masonryContainer.nativeElement);
  // }

  ngAfterViewInit() {
    this.scheduleMasonry();

    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(this.resizeTimer);

      // Wait for Bootstrap layout to finish
      this.resizeTimer = setTimeout(() => {
        this.scheduleMasonry();
      }, 80);
    });

    // 🔥 Observe the column, not masonry
    this.resizeObserver.observe(this.contentColumn.nativeElement);
  }


  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  // scheduleMasonry() {
  //   requestAnimationFrame(() => this.buildMasonry());
  // }

  scheduleMasonry() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.buildMasonry();
      });
    });
  }


  buildMasonry() {
    const container = this.masonryContainer.nativeElement;
    const items = Array.from(
      container.querySelectorAll('.masonry-item')
    ) as HTMLElement[];

    if (!items.length) return;

    // ✅ FIXED WIDTH SOURCE
    const containerWidth =
      this.contentColumn.nativeElement.clientWidth - 32;

    let columnCount = Math.floor(
      (containerWidth + this.gap) /
      (this.minItemWidth + this.gap)
    );

    columnCount = Math.max(1, Math.min(columnCount, 5));

    const itemWidth =
      (containerWidth - (columnCount - 1) * this.gap) /
      columnCount;

    const colHeights = new Array(columnCount).fill(0);

    items.forEach((item, i) => {
      const data = this.relatedData[i];
      item.style.width = `${itemWidth}px`;

      const height = data.ratio
        ? itemWidth * data.ratio
        : itemWidth * 0.75;

      let col = 0;
      for (let j = 1; j < columnCount; j++) {
        if (colHeights[j] < colHeights[col]) col = j;
      }

      item.style.transform = `translate(
      ${col * (itemWidth + this.gap)}px,
      ${colHeights[col]}px
    )`;

      colHeights[col] += height + this.gap;
    });

    container.style.height = Math.max(...colHeights) + 'px';
  }



  onlyUnique(value, index, self) {
    return self.findIndex((item) => item.id === value.id) === index;
  }
  async ngOnInit(): Promise<void> {
    this.dataService.userDetails();
    this.user = this.dataService.userDetail;
    //console.log("user", this.user);
    this.illusData = this.route.snapshot.data["illustration"];
    this.id = this.illusData?.id;
    this.titleStr = this.route.snapshot.paramMap.get("slug");
    //console.log("this.illusData", this.illusData);
    const isServer = isPlatformServer(this.platformId);
    //console.log("isServer (ngOnInit):", isServer);
    if (isPlatformServer(this.platformId)) {
      // this.populateMetaTags(this.illusData);
    }
    this.relatedIllus = this.illusData["relatedZ"];
    this.getRelatedIllustration();
    this.wishList = this.dataService.getWishlistItems();
    const result = this.wishList.filter((item) => {
      return item.id === this.id;
    });
    if (result.length > 0) {
      this.wishListAdded = true;
    } else {
      this.wishListAdded = false;
    }

    this.user = this.dataService.userDetail;
    // //console.log(this.user);
    // tooltips
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    let date = "";
    let month = "";
    let d = new Date();
    d.getDate() < 10
      ? (date = "0" + d.getDate().toString())
      : (date = d.getDate().toString());
    d.getMonth() < 10
      ? (month = "0" + (d.getMonth() + 1).toString())
      : (month = d.getMonth().toString());
    this.tDate = date + "-" + month + "-" + d.getFullYear().toString();
    if (this.user) {
      this.getDownloadData();
      (await this.dataService.getdownloadLimitationService()).subscribe(
        (singleservice) => {
          this.limit = singleservice[0]["limit"];
          if (this.downloadData.length >= this.limit) {
            this.limitExceeds = true;
            this.isFetchingLimit = false;
          } else {
            this.limitExceeds = false;
            this.isFetchingLimit = false;
          }
        }
      );
    }

    const urlSlug = this.route.snapshot.paramMap.get("slug");
    this.currentUrl = `https://illusbook.com/ai-image/${urlSlug}`;
    this.shareObj.href = encodeURIComponent(
      `https://illusbook.com/ai-image/${urlSlug}`
    );

    this.encodedWhatsAppUrl =
      "https://wa.me/?text=" +
      encodeURIComponent(`https://illusbook.com/ai-image/${urlSlug}`);
    this.encodedFacebookUrl =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(`https://illusbook.com/ai-image/${urlSlug}`);
  }

  async getDownloadData() {
    (
      await this.dataService.getdownloadHistoryByDateService(
        this.tDate,
        this.user.id
      )
    ).subscribe((singleservice) => {
      this.downloadData = singleservice;
      if (
        this.downloadData.length >= this.limit &&
        this.user &&
        !this.user.isSubscribed
      ) {
        this.limitExceeds = true;
      } else {
        this.limitExceeds = false;
      }
    });
  }

  navigateToLogin() {
    const currentUrl = this.router.url;
    sessionStorage.setItem("returnUrl", currentUrl);
    this.router.navigate(["/login"]);
  }

  navigateToSubscribe() {
    const currentUrl = this.router.url;
    sessionStorage.setItem("returnUrl", currentUrl);
    this.router.navigate(["/pricing"]);
  }

  async setUrl(iData) {
    let furl = this.illusData.jpeg || this.illusData.png;
    let iurl =
      this.illusData?.previewUrl || this.illusData.jpeg || this.illusData.png;
    let type = "png";

    if (this.illusData.jpeg) {
      type = "jpg";
    }

    if (!this.user) {
      this.router.navigate(["/login"]);
    } else {
      this.imgUrl = iurl;
      if (
        this.user.isSubscribed ||
        (this.downloadData.length <= this.limit && !this.limitExceeds)
      ) {
        this.fileService.downloadFile(furl).subscribe((response: any) => {
          let blob: any = new Blob([response], {
            type: "text/json; charset=utf-8",
          });
          const url = window.URL.createObjectURL(blob);
          saveAs(blob, this.illusData.title + "." + type);
        }),
          (
            error: any //console.log("Error downloading the file"),
          ) =>
            () =>
              console.info("File downloaded successfully");

        let data = { ...this.illusData };
        data["createdAt"] = new Date().toString();
        data["createdOn"] = +new Date();
        data["downloadedDate"] = this.tDate;
        data["uid"] = this.user.id;
        await this.afs.collection("downloadHistroyMaster").add(data);
        this.getDownloadData();
      }
    }
  }
  // async downloadZip() {
  //   if (!this.user) {
  //     this.router.navigate(["/login"]);
  //   } else {
  //     if (this.downloadData.length <= this.limit && !this.limitExceeds) {
  //       const zip = new JSZip();
  //       const folder = zip.folder(this.illusData.title);
  //       const files = this.illusData.files;
  //       for (let i = 0; i < files.length; i++) {
  //         const file = files[i];
  //         const response = await fetch(file);
  //         const blob = await response.blob();
  //         folder.file(file.split("/").pop(), blob);
  //       }
  //       zip.generateAsync({ type: "blob" }).then((content) => {
  //         FileSaver.saveAs(content, this.illusData.title + ".zip");
  //       });
  //       let data = { ...this.illusData };
  //       data["createdAt"] = new Date().toString();
  //       data["createdOn"] = +new Date();
  //       data["downloadedDate"] = this.tDate;
  //       data["uid"] = this.user.id;
  //       await this.afs.collection("downloadHistroyMaster").add(data);
  //       this.getDownloadData();
  //     }
  //   }
  // }
  async addToFavorite(data) {
    this.user = this.dataService.userDetail;

    if (!this.user) {
      this.router.navigate(["/login"]);
      return;
    }

    const updatedList = await this.dataService.addToWishlist(
      data,
      this.user.id
    );

    this.wishList = updatedList;

    this.wishListAdded = this.wishList.some((item) => item.id === data.id);
  }

  closeModal() {
    this.closebutton.nativeElement.click();
  }

  socialShare(data) {
    this.user = this.dataService.userDetail;
    if (this.user) {
      if (data == "fb") {
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${this.share}&display=popup&ref=plugin&src=share_button`
        );
      } else if (data == "wa") {
        window.open(`https://web.whatsapp.com/send?text=${this.share}`);
      } else if (data == "tweet") {
        window.open(
          `http://twitter.com/intent/tweet?text=${this.illusData.slug}&url=${this.share}`
        );
      } else if (data == "ln") {
        window.open(
          `https://www.linkedin.com/shareArticle?mini=true&url=${this.share}`
        );
      }
    } else {
      this.router.navigate(["/login"]);
    }
  }


      initIllusLoad() {
    this.currentPage = 1;
    this.visibleRelatedData = this.relatedData.slice(0, this.pageSize);
  }

  loadMoreIllus() {
    this.isLoadingMore = true;

    setTimeout(() => {
      this.currentPage++;

      this.visibleRelatedData = this.relatedData.slice(
        0,
        this.currentPage * this.pageSize
      );

      this.isLoadingMore = false;
    }, 300);
  }

    get hasMoreIllus(): boolean {
    return this.visibleRelatedData.length < this.relatedData.length;
  }
}
